module.exports = __webpack_public_path__ + "static/media/3.4f86cfd8.jpg";